import * as React from "react";
import { cn } from "../_internal/cn";
import type { TypeEyebrowTokenProps } from "./EyebrowTokenTypes";

/**
 * EyebrowToken — a small gray pill that sits above a headline to carry a short
 * bit of context: a date (e.g. "May 31, 2026"), category, or kicker.
 *
 * A faithful match of the Figma "Token / Non Clickable / Default" design — a
 * solid `#dee1e1` fill with a matching border, 6px radius, and small body text.
 * Styled via `eyebrow-token.css` (Seeds CSS custom properties); consumers import
 * the classes through `@sproutsocial/racine/css/components`. Overrides come via
 * standard `className` / `style`.
 */
const EyebrowToken = React.forwardRef<HTMLSpanElement, TypeEyebrowTokenProps>(
  ({ children, className, ...props }, ref) => (
    <span ref={ref} className={cn("seeds-eyebrow-token", className)} {...props}>
      {children}
    </span>
  )
);

EyebrowToken.displayName = "EyebrowToken";

export default EyebrowToken;
